import {memo, ShapeComponent, shapeComponent, StyleSheet, View} from "shared/base"
import React, {useMemo} from "react"
import FontAwesomeIcon from "react-native-vector-icons/FontAwesome"
import TextInput from "./text-input"

const styles = StyleSheet.create({
  icon: {
    marginRight: 15,
    marginVertical: "auto",
    fontSize: 16,
    color: "#aaa"
  },
  iconContainer: {
    position: "absolute",
    right: 0,
    height: "100%"
  }
})

export default memo(shapeComponent(class ComponentsUtilsInputField extends ShapeComponent {
  render() {
    const {icon, style, transparent, ...restProps} = this.props
    const actualStyle = useMemo(() => {
      const actualStyle = this.stylingFor("textInput", Object.assign(
        {
          backgroundColor: transparent ? undefined : "#fff",
          border: transparent ? undefined : "1px solid #dcdcdc",
          borderRadius: 10,
          boxShadow: transparent ? undefined : "0 8px 10px 0 rgba(0, 0, 0, 0.07)",
          paddingTop: 17,
          paddingRight: 26,
          paddingBottom: 17,
          paddingLeft: 26,
          color: "#666",
          fontSize: 17
        },
        style
      ))

      if (icon) {
        actualStyle.paddingRight = 38
      }

      return actualStyle
    }, [icon, transparent, style])

    return (
      <>
        {icon &&
          <View style={styles.iconContainer}>
            <FontAwesomeIcon
              name={icon}
              style={styles.icon}
            />
          </View>
        }
        <TextInput
          placeholderTextColor="#b0b0b0"
          style={actualStyle}
          {...restProps}
        />
      </>
    )
  }
}))
